import React, { Component } from "react"
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { BasicLazyParams } from '../../../utile';
import Authentication from './../../session';
import Authorizer, { PERMISSIONS } from '../../session/authorizer';
import _ from 'lodash';
import { AddIcon2, ClassetEditIcon, EyeIconClasset } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from './../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import './styles.scss'
import BranchToSectionMultiDDPreFill from "../../BaseDropdownComponents/BranchToSectionMultiDDPreFill";
import EditStudentInfoNew from "./EditStudentInfoNew";
// import EditStudentInfo from "./EditStudentInfo";
import { RadioButton } from "primereact/radiobutton";
import ClassetStudentSearchFilter from "../../Search/ClassetStudentSearchFilter";

class StudentInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            users: [
            ],
            filterData: null,

            columns: [
                { columnName: 'Created At', isVisible: false, id: 'createDateTime' }],

            isUserNameSearch: false,
            username: '',
            boardId: null,
            classId: null,
            groupId: null,
            sectionIds: [],
            boards: [],
            classes: [],
            groups: [],
            sections: [],
            branchLevels: {},
            lazyParams: BasicLazyParams,
            users: [],
            selectedUser: [],
            globalSearch: '',
            totalRecords: 0,

            dropdownsData: {},
            searchLevel: 1,
            studentId: null,
            searchValue: '',
        };
        this.service = new Service();
        this.studentSearchRef = React.createRef();
    }

    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id === id)[0].isVisible;
    }

    reFormUsersObj = (users) => {
        let allUsers = [];
        users.length &&
            users.map((user) => {
                let _user = {
                    ...user
                };
                if (user.user_info) {
                    for (let key in user.user_info) {
                        _user[key] = user.user_info[key];
                    }
                }
                allUsers.push({ ..._user });
                return null;
            });

        return allUsers;
    }



    filterUsersData = (dropdownsData) => {
        this.setState({
            isLoading: true,
            users: []
        });

        let { lazyParams, globalSearch, filterData, statusFilter } = this.state;
        const payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            classId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            studentId: this.state?.dropdownsData?.studentIds,
        }

        const url = `${baseUrlAdmin}/user/filter/allusers?academicYear=${localStorage.getItem('userAcademicYear')}&limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    users: res.res.Items,
                    totalRecords: res.res.totalRecords
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }
    componentDidMount() {
        if (this.state?.dropdownsData?.sectionId) {
            this.filterUsersData();

        }
    }


    onSearchClick = (filterData) => {

        this.setState({
            filterData
        }, this.filterUsersData)


    }
    onPage = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.filterUsersData);
    }

    onSort = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.filterUsersData);
    }

    onFilter = (event) => {

        event['first'] = 0;
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.filterUsersData);
        //  this.setState({ lazyParams: event }, this.getOrganizations);
    }
    setDropdownValues = (dropdownsData, payload) => {
        this.setState({
            dropdownsData,
            studentIds: payload?.studentIds || [],
            enrollmentIds: payload?.enrollmentIds || [],
        }, () => this.filterUsersData())
    }
    gradeSectionBodyTemplate = (rowData) => {
        return `${rowData.user_info["custom:grade"]}-${rowData.user_info.sectionName}`;
    }
    setIsShowEditForm = () => {
        this.setState({ isShowEditForm: false })
    }

    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value, studentId: '', searchValue: '', studentsData: [] }, () => {
            // Clear child input when radio changes
            if (this.studentSearchRef.current && this.studentSearchRef.current.clearInput) {
                this.studentSearchRef.current.clearInput();
            }
        });
    };

    // onHandlePayment = () => {
    //     const { balanceAmount } = this.state;
    //     const url = `${baseUrlAdmin}/cashfree/create-order`;
    //     const payload = {
    //         "order_amount": balanceAmount, // Use the entered amount
    //         "order_currency": "INR",
    //         "order_id": "devstudio_" + Date.now(),
    //         "customer_details": {
    //             "customer_id": "devstudio_user",
    //             "customer_phone": "8474090589"
    //         },
    //         "order_meta": {
    //             "return_url": "https://www.cashfree.com/devstudio/preview/pg/web/popupCheckout?order_id={order_id}"
    //         }
    //     }
    //     this.setState({ isLoading: true });
    //     this.service
    //         .post(url, payload, true)
    //         .then((response) => {
    //             this.setState({ isLoading: false });
    //             if (response.status && response.res?.data?.payment_session_id) {
    //                 this.setState({
    //                     showCheckout: true,
    //                     paymentSessionId: response.res.data.payment_session_id
    //                 });
    //                 console.log('Order created');
    //             } else {
    //                 this.setState({ isLoading: false });
    //                 this.toast.show({
    //                     severity: 'error',
    //                     summary: 'Error',
    //                     detail: response.errMessage || 'Failed to create order',
    //                     life: 3000
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             this.setState({ isLoading: false });
    //             this.toast.show({
    //                 severity: 'error',
    //                 summary: 'Error',
    //                 detail: 'An error occurred while creating order',
    //                 life: 3000
    //             });
    //             console.error('Error in order creation:', error);
    //         });
    // }

    // Show/hide dialog handlers
    // showBalanceDialog = () => {
    //     this.setState({ showBalanceDialog: true, balanceAmount: null });
    // };
    // hideBalanceDialog = () => {
    //     this.setState({ showBalanceDialog: false, balanceAmount: null });
    // };

    // Handler for Pay button in dialog
    // handleBalancePay = () => {
    //     // You can call your payment API here using this.state.balanceAmount
    //     this.hideBalanceDialog();
    //     this.toast.show({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: `Initiated payment for ₹${this.state.balanceAmount}`,
    //         life: 3000
    //     });
    // };

    // Show Add Balance dialog when Pay Now is clicked
    // onPayNowClick = () => {
    //     this.setState({ showBalanceDialog: true, balanceAmount: null });
    // };

    render() {

        const header = (
            <div className="flex justify-content-between bg-white align-items-center">
                <div className="flex align-items-center gap-3">
                    {/* <h2 className="sideHeading">Student Information</h2> */}
                </div>
            </div>
        );

        return (
            <div>

                <div className="flex">
                    <div className="flex flex-column justify-content-center align-items-center mt-3">
                        <RadioButton
                            inputId="ingredient1"
                            onChange={(e) => this.handleSearchLevel(1)}
                            checked={this.state.searchLevel === 1}
                        />
                    </div>

                    <div>
                        {/* <BranchToSectionApprovalHierarchy
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                                approvalType={'feeConcession'}
                            /> */}
                        <BranchToSectionMultiDDPreFill
                            ref={this.studentSearchRef}
                            selectedValue={this.state.searchLevel}
                            setValues={this.setDropdownValues}
                        />

                    </div>
                </div>

                {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}

                <div className="flex mt-4 justify-content-between align-items-center">
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton
                                inputId="ingredient2"
                                onChange={(e) => this.handleSearchLevel(2)}
                                checked={this.state.searchLevel === 2}
                            />
                        </div>

                        <div className="flex field ml-4">
                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                            />
                        </div>
                    </div>
                    <div className="align-items-center flex mt-5">
                        <Authorizer permId={PERMISSIONS.STUDENTS_BULK_UPLOAD} >
                            <Button onClick={() => { this.props.navigate('/userBulkupload') }} style={{
                                height: "44px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                background: "#076EFF",
                                color: "#fff",
                                border: "none",
                                padding: "0 24px",
                                cursor: "pointer",
                                fontFamily: "InterRegular"
                            }}>
                                <p>Bulk Upload</p>
                                <AddIcon2 />
                            </Button>
                        </Authorizer>
                    </div>
                </div>





                <div className="datatable-div mt-5">

                    <DataTable ref={(el) => this.dt = el}
                        value={this.state.users}
                        dataKey="id"
                        paginator
                        lazy
                        responsiveLayout="scroll"
                        columnResizeMode="expand"
                        resizableColumns
                        onPage={this.onPage}
                        first={this.state.lazyParams.first}
                        last={this.state.totalRecords}
                        rows={this.state.lazyParams.rows}
                        totalRecords={this.state.totalRecords}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        globalFilter={this.state.globalFilter}
                        rowClassName={() => 'table-row-style'}
                        header={header}
                    >

                        <Column filterField="user_info.given_name" field="user_info.given_name" header="Student Name" body={(rowData, { rowIndex }) => {
                            return (
                                <p>{`${rowData?.user_info?.firstName} ${rowData?.user_info?.lastName}`}</p>

                            )
                        }} />
                        <Column filterField="user_info.enrollmentId" field="user_info.enrollmentId" header="Enrollment Id " />
                        <Column field="user_info.categoryName" header="Admission Category " />


                        <Column filterField="user_info.branchId" field="user_info.branchName" header="Branch" />
                        <Column filterField="user_info.custom:board" field="user_info.custom:board" header="Board" />
                        <Column filterField="user_info.custom:grade" field="custom:grade" body={this.gradeSectionBodyTemplate} header="Grade-Section" />
                        <Column filterField="user_info.parentContactNo" field="user_info.parentContactNo" header="Parent Contact" body={(rowData, { rowIndex }) => {
                            return (
                                <p>{rowData?.user_info?.parentContactNo}</p>

                            )
                        }} />
                        {/* <Column  filterField="user_info.email" field="user_info.email" header="Email" /> */}
                        <Column header="Status" body={(rowData, { rowIndex }) => {
                            return (<Button className='formCancelButton ' style={{ backgroundColor: rowData.user_info?.status == "Active" ? '#E1F7D8' : '#FFECF1', borderColor: 'lightgray', borderWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 15, padding: 0, height: '32px', width: "75px" }} onClick={() => this.setState({ isTransferDialogOpen: true })} >
                                <p className='sideHeading' style={{ fontSize: 12, lineHeight: '16px', color: rowData.user_info?.status == "Active" ? '##1E6D00' : '#BF0031' }}>{rowData.user_info?.status == "Active" ? "Active" : "InActive"}</p>
                            </Button>)
                        }} />
                        <Column className=' ' header="Actions" body={(rowData, { rowIndex }) => {
                            return (
                                <div className="flex align-items-center gap-3">
                                    {/*  <Button className='formCancelButton ' style={{ backgroundColor: rowData.user_info?.status == "Active" ? '#E1F7D8' : '#FFECF1', borderColor: 'lightgray', borderWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 15, padding: 0, height: '32px', width: "75px" }} onClick={() => this.setState({ isTransferDialogOpen: true })} >
                                        <p className='sideHeading' style={{ fontSize: 12, lineHeight: '16px', color: rowData.user_info?.status == "Active" ? '##1E6D00' : '#BF0031' }}>{rowData.user_info?.status == "Active" ? "Active" : "InActive"}</p>
                                    </Button> */}
                                    <div
                                        onClick={() => {
                                            const userId = rowData.user_id;
                                            if (userId) {
                                                this.props.navigate(`/studentProfile?studentId=${encodeURIComponent(userId)}`);
                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: 'Student ID not found',
                                                    life: 3000
                                                });
                                            }
                                        }}
                                        className="cursor-pointer"
                                    >
                                        <EyeIconClasset height={38} width={32} />
                                    </div>
                                    <div className=" flex justify-content-end align-items-center cursor-pointer"
                                        onClick={() => this.setState({ isShowEditForm: true, rowData: { ...rowData } })}
                                    >
                                        <ClassetEditIcon width={32} height={32} color={'#000000'} />
                                    </div>
                                </div>

                            )
                        }} ></Column>


                    </DataTable>
                    {
                        this.state.isLoading && <>
                            <LoadingComponent />
                        </>
                    }

                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                    <Dialog
                        blockScroll={true}
                        visible={this.state.isShowEditForm}
                        draggable={false}
                        closeOnEscape={false}
                        className="ma-alert-box"
                        dismissableMask={false}
                        closable={true}
                        style={{
                            width: '90%',
                            height: 'auto',
                            maxHeight: '90%',
                            margin: '0 auto'
                        }}
                        header={() => {
                            return <h2 className="transport-header py-2">Edit Student</h2>;
                        }}
                        // footer={() => (

                        // )}
                        onHide={() => {
                            this.setState({
                                isShowEditForm: false,
                            });
                        }}
                    >
                        <EditStudentInfoNew
                            EditData={this.state.rowData}
                            isShowEditForm={this.setIsShowEditForm}
                            filterUsersData={this.filterUsersData}
                        />
                         {/* <EditStudentInfo
                            EditData={this.state.rowData}
                            isShowEditForm={this.setIsShowEditForm}
                            filterUsersData={this.filterUsersData}
                        /> */}
                    </Dialog>
                </div>
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({


});
export default connect(null, {

})(Authentication(withRouter(StudentInfo)));